import { getEffectiveFirebaseIdToken } from '@/features/impersonation/effectiveFirebaseToken'
import { api } from '@/services/api'

export type BulkCloseItem = {
  id: string
  status: 'pending' | 'closed' | 'skipped' | 'failed'
  reason?: string
  webhook?: 'claimed' | 'sent' | 'not_configured' | 'failed' | 'unknown'
}
export type BulkCloseJob = {
  id: string
  companyId: string
  status: 'pending' | 'processing' | 'completed'
  items: BulkCloseItem[]
  total: number
  processed: number
  closed: number
  skipped: number
  failed: number
  createdAt: number
  updatedAt: number
}

async function authHeaders() {
  return { Authorization: `Bearer ${await getEffectiveFirebaseIdToken()}` }
}

export async function createBulkCloseJob(input: {
  companyId: string
  chatIds: string[]
  categoryId: string
  subCategoryId?: string
  report?: string
}) {
  const response = await api.post<BulkCloseJob>('/chats/bulk-close-jobs', input, { headers: await authHeaders() })
  return response.data
}

export async function listBulkCloseJobs(companyId: string) {
  const response = await api.get<BulkCloseJob[]>('/chats/bulk-close-jobs', {
    params: { companyId },
    headers: await authHeaders()
  })
  return response.data
}
